import { render } from "./VxInputGroup.vue?vue&type=template&id=ed68ee56"
import script from "./VxInputGroup.vue?vue&type=script&lang=js"
export * from "./VxInputGroup.vue?vue&type=script&lang=js"

import "./VxInputGroup.vue?vue&type=style&index=0&id=ed68ee56&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__